import { inject, injectable } from 'inversify';
import CookieRepository from '@framework/browser/storage/CookieRepository';
import TrackingConsent from '@framework/cookie-consent/TrackingConsent';
import { ConsentCategory } from '@framework/cookie-consent/constants';
import { IAiSidebarState } from '@/creditflowresearch/domain/vo/AiSidebar';
import {
  AI_SIDEBAR_COOKIE_NAME,
  INITIAL_AI_SIDEBAR_STATE,
} from '@/creditflowresearch/application/AiSidebar/constants';

const parseSidebarState = (value?: string): IAiSidebarState => {
  try {
    const { isOpen, width } = JSON.parse(value ?? '');

    return {
      isOpen: isOpen === true,
      width: typeof width === 'number' && width > 0 ? width : null,
    };
  } catch {
    return INITIAL_AI_SIDEBAR_STATE;
  }
};

@injectable()
class AiSidebarRepository {
  constructor(
    @inject(CookieRepository) private readonly cookiesRepository: CookieRepository,
    @inject(TrackingConsent) private readonly trackingConsent: TrackingConsent,
  ) {}

  getSidebarState = async (): Promise<IAiSidebarState> => {
    return parseSidebarState(await this.cookiesRepository.get(AI_SIDEBAR_COOKIE_NAME));
  };

  setSidebarState = (state: IAiSidebarState): void => {
    if (!this.trackingConsent.hasConsent(ConsentCategory.Functional)) {
      return;
    }

    this.cookiesRepository.set(AI_SIDEBAR_COOKIE_NAME, JSON.stringify(state), {
      domain: '',
      expires: 365,
    });
  };
}

export default AiSidebarRepository;
